import { Form } from "antd";
import styled from "styled-components";

export const SplitAccountsConfigWrapper = styled(Form)`
  position: relative !important;

  .split-type {
    width: 200px;
    margin-bottom: 20px;
  }

  .split-accounts-list {
  }

  .list {
    border: 1px solid #c0c0c0;
    border-radius: 6px;
    max-height: 565px;
    overflow-y: auto;

    .line-item {
      display: flex;
      align-items: center;

      border-bottom: 1px solid #c0c0c0;
      padding: 16px 20px 0px 20px;

      &:last-child {
        border-bottom: 0px;
        margin-bottom: 0px;
      }

      .index {
        margin-right: 20px;
        font-size: 14px;
        margin-bottom: 14px;
      }

      .account {
        width: 200px;
      }

      .value {
        width: 180px;
      }
      .value-rest {
        height: 34px;
        text-align: left;
        width: 180px;
        padding-left: 10px;
      }

      .priority {
        width: 180px;
      }

      .ant-form-item-control {
        min-height: 59px;
      }

      .add-button {
        margin-left: auto;
        margin-bottom: 10px;
      }
    }
  }

  .footer {
    margin-top: auto;
    display: flex;
    justify-content: ${(props) => (props.splitType !== "percentage" ? `flex-end` : `space-between`)};
    /* background: #ffff; */
    height: 60px;
    align-items: center;
    width: -webkit-fill-available;

    .btn-div {
    }
  }

  /* .footer {
    position: fixed;
    bottom: 0;
    background: #ffff;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.splitType !== "percentage" ? `flex-end` : `space-between`)};
    z-index: 999;
    width: -webkit-fill-available;
    margin-left: -24px;

    .btn {
      margin: auto 10px auto 0;
    }
  } */

  .ant-select-selection-selected-value {
    .account-select {
      .option-number-text {
      }
      .option-name-text {
        display: none;
      }
    }
  }
`;
